import { ReactElement } from "react";

interface ImpactCardProps {
    imageComponent: ReactElement;
    header: string;
    description: string;
};

const ImpactCard = ({ imageComponent, header, description }: ImpactCardProps) => {
    
    return (
        <div className="max-w-xs min-h-32 flex flex-col items-center justify-end">
            <div>
                {imageComponent}
            </div>
            <p className="text-lg font-semibold text-center my-1">{header}</p>
            <p className="text-lg text-center">{description}</p>
        </div>
    );
};

export default ImpactCard;